// eslint-disable-next-line no-restricted-imports -- pre-existing Immutable usage; migrate off when touched
import { Map } from 'immutable';

import { ACTIVATE_NAV, DEACTIVATE_NAV, TOGGLE_NAV } from '@sophocles/features/navigation/navigationActions';

const initialState = Map({
  admin: false,
  services: false,
  support: false,
  customer: false,
  siteGroup: false,
  site: false,
});

function navigationReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_NAV:
      return state.set(action.level, !state.get(action.level, false));
    case ACTIVATE_NAV:
      return state.set(action.level, true);
    case DEACTIVATE_NAV:
      return state.set(action.level, false);
    default:
      return state;
  }
}

export default navigationReducer;
